import { Grid, Link, List, ListItem, ListItemText } from '@mui/material';

const CandidateInfo = ({ contact, previous, experiences, address }) => {
  return (
    <Grid container spacing={3}>
      <Grid
        container
        rowSpacing={{ sm: 1, md: 0 }}
        columns={{ xs: 1, sm: 2, md: 1 }}
        component={List}
        size={12}
        disablePadding
      >
        <Grid size={1}>
          <InfoItem
            primary="Email"
            secondary={<Link href={`mailto:${contact.email}`}>{contact.email}</Link>}
          />
        </Grid>
        <Grid size={1}>
          <InfoItem sx={{ flexBasis: '50%' }} primary="Phone No" secondary={contact.phone} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Address" secondary={contact.address} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Previous Company" secondary={previous.prevCompany} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Previous Salary" secondary={previous.prevCTC} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Notice Period" secondary={previous.noticePeriod} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Qualification" secondary={experiences.qualification} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Current Address" secondary={address.currentAddress} />
        </Grid>
        <Grid size={1}>
          <InfoItem primary="Permanent Address" secondary={address.permanentAddress} />
        </Grid>
      </Grid>
    </Grid>
  );
};

const InfoItem = ({ primary, secondary, primaryProps, secondaryProps, props, sx }) => {
  return (
    <ListItem disableGutters sx={{ ...sx }}>
      <ListItemText
        primary={primary}
        secondary={secondary}
        sx={{ my: 1 }}
        slotProps={{
          primary: {
            sx: {
              mb: 1,
              typography: 'subtitle1',
              fontWeight: 700,
              display: 'block',

              ...primaryProps,
            },
          },
          secondary: {
            sx: {
              display: 'block',
              typography: 'body1',
              ...secondaryProps,
            },
          },
        }}
        {...props}
      />
    </ListItem>
  );
};

export default CandidateInfo;
